import Inputmask from "inputmask";


export default function mask() {

    const maskEmail = document.querySelectorAll('[data-mask-email]');
    const maskName = document.querySelectorAll('[data-mask-name]');
    const maskPass = document.querySelectorAll('[data-mask-pass]');

    if ( maskEmail.length ) {
        for (let el of maskEmail ) {
            el.addEventListener('input', function(e) {
                this.value = this.value.replace(/[^a-zA-Z0-9@._-]/g, '');
            });
        }
    }

    if ( maskName.length ) {
        for (let el of maskName ) {
            el.addEventListener('input', function(e) {
                this.value = this.value.replace(/[^а-яА-ЯёЁ]/g, '');
            });
        }
    }

    if (maskPass.length) {
        for (let el of maskPass) {
            el.addEventListener('input', function(e) {
                // Разрешаем: английские буквы (a-z, A-Z), цифры (0-9) и стандартные символы
                this.value = this.value.replace(/[^a-zA-Z0-9!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?`~ ]/g, '');
            });
        }
    }

    if(document.querySelectorAll('input[data-mask-tel]').length > 0) {
        let selector = document.querySelectorAll('input[data-mask-tel]');
        let im = new Inputmask('+7 (999) 999-99-99', {
        showMaskOnHover: false,
        });
        im.mask(selector);

        for (let el of selector ) {
            el.oninput = function() {
                if ( el.value.replace(/[()+_ -]/g,'').length < 11 ) {
                    el.setCustomValidity("Заполните телефон полностью");
                } else {
                    el.setCustomValidity("");
                }
            }
        }

    }

}